var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.list.length > 0
      ? _c(
          "div",
          { staticClass: "product-list" },
          _vm._l(_vm.list, function(item, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "product-list-content" }, [
                _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("问卷类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.survey_type))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("问卷名称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("提交时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.create_time))]
                      )
                    ])
                  ])
                ])
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "theRecords" }, [
      _c("div", { staticClass: "basic-information-title" }, [
        _vm._v("问卷记录")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "redactImg" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbaafa40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbaafa40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/theRecords.vue
// module id = null
// module chunks = 